import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const NavBar = ({ name }: { name: string }) => {
  const nav = useNavigate();
  const onClickBtn = () => {
    nav(-1);
  };
  return (
    <NavBarWrap>
      <div className="BannerInner">
        <div className="Username">
          <p>{name}</p>
        </div>
        {/* <p>{!user.emailVerified && " 이메일 인증 미완료"}</p> */}
      </div>
      <div className="LeftBtn">
        <div onClick={onClickBtn}>
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask id="path-1-inside-1_568_503" fill="white">
              <path d="M16.9707 8.48535L8.48542 16.9706L0.000140667 8.48535L8.48542 7.03335e-05L16.9707 8.48535Z" />
            </mask>
            <path
              d="M0.000140667 8.48535L-0.706966 7.77824L-1.41407 8.48535L-0.706966 9.19246L0.000140667 8.48535ZM9.19253 16.2635L0.707247 7.77824L-0.706966 9.19246L7.77832 17.6777L9.19253 16.2635ZM0.707247 9.19246L9.19253 0.707177L7.77832 -0.707036L-0.706966 7.77824L0.707247 9.19246Z"
              fill="#314AF3"
              mask="url(#path-1-inside-1_568_503)"
            />
          </svg>
        </div>
      </div>
    </NavBarWrap>
  );
};

export default NavBar;

const NavBarWrap = styled.div`
  position: relative;
  padding: 40px 0px 0px 0px;
  /* border-bottom: 1px solid #314af3; */
  .BannerInner {
    display: flex;
    align-items: end;
    justify-content: space-between;
    padding: 0px 24px 0px 0px;
    .Username {
      width: fit-content;
      padding: 8px 24px;
      background-color: #314af3;
      margin-right: 12px;
      p {
        color: white;
        font-family: gmarket-sans-medium;
        font-size: 16px;
      }
    }
    p {
      font-family: gmarket-sans-medium;
      font-size: 12px;
      color: #f94646;
    }
  }
  .LeftBtn {
    div {
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      svg {
      }
    }
  }
`;
